import React from "react";
import { ArrowLeft, ArrowRight, LoaderCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export function StepFooter({
  onBack,
  onContinue,
  continueLabel,
  disabled = false,
  busy = false,
  compact = false,
}) {
  const { t } = useTranslation();

  return (
    <footer
      className={`kyc-step-footer z-20 shrink-0 border-t border-slate-200 bg-white/95 backdrop-blur sm:mx-0 sm:border-0 sm:bg-transparent sm:px-0 sm:pb-0 sm:pt-0 sm:backdrop-blur-none ${
        compact
          ? "-mx-4 mt-3 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3"
          : "-mx-5 mt-8 px-5 pb-[max(1rem,env(safe-area-inset-bottom))] pt-4"
      }`}
    >
      <button
        type="button"
        onClick={onContinue}
        disabled={disabled || busy}
        className={`inline-flex w-full items-center justify-center gap-2 rounded-lg bg-teal-700 px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-800 active:scale-[0.99] disabled:cursor-not-allowed disabled:bg-slate-300 disabled:shadow-none ${
          compact ? "min-h-11 py-2.5" : "min-h-12 py-3"
        }`}
      >
        {busy && (
          <LoaderCircle className="size-4 animate-spin" aria-hidden="true" />
        )}
        {continueLabel || t("common.next")}
        {!busy && <ArrowRight className="size-4" aria-hidden="true" />}
      </button>
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          disabled={busy}
          className={`inline-flex w-full items-center justify-center gap-2 rounded-lg text-sm font-semibold text-slate-500 transition hover:bg-slate-50 hover:text-slate-800 disabled:opacity-50 ${
            compact ? "mt-1 min-h-9" : "mt-2 min-h-10"
          }`}
        >
          <ArrowLeft className="size-4" aria-hidden="true" />
          {t("common.back")}
        </button>
      )}
    </footer>
  );
}
